import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { Box, Button, Chip, Paper, Typography } from '@mui/material';
import { useTokens } from 'theme';
import { SKIP_FORM_MESSAGE, composeFormMessage, toggleAnswer } from './composeForm';

/**
 * The model's clarifying questions as option chips. Answering sends one plain
 * message; only the latest answer's form is interactive (`disabled` otherwise).
 */
export default function AnswerForm({ form, disabled, onSend }) {
  const { t: translate } = useTranslation();
  const t = useTokens();
  const [answers, setAnswers] = useState({});
  const questions = Array.isArray(form?.questions) ? form.questions : [];
  if (questions.length === 0) return null;

  const message = composeFormMessage(questions, answers);

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 1.5, borderColor: t.link }}>
      {questions.map((question) => (
        <Box key={question.id} sx={{ mb: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.75 }}>
            {question.text}
            {question.multiple && (
              <Typography component="span" variant="caption" color="text.secondary">
                {' '}{translate('assistant.answerFormMultipleChoicesAllowed')}</Typography>
            )}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
            {(question.options || []).map((option) => {
              const selected = (answers[question.id] || []).includes(option);
              return (
                <Chip
                  key={option}
                  label={option}
                  size="small"
                  clickable={!disabled}
                  disabled={disabled}
                  color={selected ? 'primary' : 'default'}
                  variant={selected ? 'filled' : 'outlined'}
                  aria-pressed={selected}
                  onClick={() => setAnswers((prev) => toggleAnswer(prev, question, option))}
                />
              );
            })}
          </Box>
        </Box>
      ))}
      {!disabled && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button size="small" color="inherit" onClick={() => onSend(SKIP_FORM_MESSAGE())}>{translate('assistant.answerFormSkip')}</Button>
          <Button size="small" variant="contained" disabled={!message} onClick={() => onSend(message)}>{translate('assistant.answerFormSend')}</Button>
        </Box>
      )}
    </Paper>
  );
}
